// extracted by mini-css-extract-plugin
export default {"setting":"Option--setting--Gsvqv","label":"Option--label--jmD6S","description":"Option--description--2zDdI","title":"Option--title--M-tjF","detail":"Option--detail--9-DwE"};